import ValueMappingMissingValueRow from '@Components/ValueMappingMissingValueRow';
import { Typography } from '@mui/material';
import { t } from 'i18next';
import React from 'react';
import {
	ValueMappingMissingValueRowWrapper,
	CenteredWrapper,
} from './ValuemappingMappingRowList.styles';
import { FormikErrors } from 'formik';
import { ValuemappingProfileFormShape } from '@Types/valuemappingForm.types';

interface ValueMappingMissingRowProps {
	mappingMethodOptionItems: {
		key: string;
		value: string;
		label: string;
	}[];
	index: number;
	errors: Partial<FormikErrors<ValuemappingProfileFormShape>>;
}

export default function ValueMappingMissingRow({
	index,
	mappingMethodOptionItems,
	errors,
}: ValueMappingMissingRowProps) {
	return (
		<ValueMappingMissingValueRowWrapper data-cy="missingValue">
			<ValueMappingMissingValueRow
				index={index}
				mappingMethodOptionItems={mappingMethodOptionItems}
				errors={errors}
			/>
			<div style={{ paddingTop: '1rem' }}>
				<CenteredWrapper>
					<Typography>{t('When the value is:')}</Typography>
				</CenteredWrapper>
			</div>
		</ValueMappingMissingValueRowWrapper>
	);
}
